import { i18n } from "../services/i18nService";
import { isUserAccountActive } from "../services/accountStatusService";
import { getAppState } from "../state";

export function isFVODFreeToAir(tagsArr) {
  const freeToAirTag = tagsArr.find(tag => tag.tagTitle === "free-to-air");
  if (freeToAirTag) {
    return true;
  }
  return false;
}

// format hero carousel to show free tags etc
export function getTitlesFormattedForHeroCarousel(titles = [], isUserActive) {
  if (!isUserActive) {
    titles.forEach(title => {
      if (title?.tags && title?.tags.find(tag => tag.tagTitle === "free-to-air")) {
        // console.log(title.title + " is free")
        title.isFreeContent = true;
        title.freeTagText = i18n.get("pages.tags.tagText");
        if(title?.badges?.length > 0){ 
          title.freeTagText = title.badges[0]
        }
      } else {
        title.isFreeContent = false;
      }
    });
  }
  // console.log("heroTitles",titles)
  return titles;
}

export function getFVODTitlesFormattedForFullCatalog(titles = [], componentThis) {
  // console.clear()
  // console.log(componentThis, titles);
  // return titles
  if (!isUserAccountActive(componentThis?.props?.applicationState?.userAccountStatus)) {
    titles.forEach(title => {
      if (title?.tags && title?.tags.find(tag => tag.tagTitle === "free-to-air")) {
        // console.log(title);
        title.isFreeContent = true;
        title.freeTagText = i18n.get("pages.tags.tagText");
        if(title?.badges?.length > 0){ 
          title.freeTagText = title.badges[0]
        }
      } else {
        title.isFreeContent = false;
      }
    });
    return titles;
  } else {
    return titles;
  }
}
export function getFVODTitlesFormattedForEpisodes(titles = []) {
  const appState = getAppState();
  // return titles
  if (!isUserAccountActive(appState?.userAccountStatus)) {
    titles.forEach(title => {
      if (title?.tags && title?.tags.find(tag => tag.tagTitle === "free-to-air")) {
        // console.log(title);
        title.isFreeContent = true;
        title.freeTagText = i18n.get("pages.tags.tagText");
      } else {
        title.isFreeContent = false;
      }
    });
    return titles;
  } else {
    return titles;
  }
}

// Extract the first tagScheme: "urn:peg:badge" from the tags array and return its tagTitle, else return i18n.get("pages.tags.tagText")
export function getBadgeTextFromTags(tags = []) {
  const badge = tags.find(tag => tag.tagScheme === "urn:peg:badge");
  if (badge) {
    return badge.tagTitle;
  }
  return i18n.get("pages.tags.tagText");
}